import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';


type EachOtherBottleSize = {
  packCode: string
  bottleQty: string
}

type OtherBottleSizes = EachOtherBottleSize[]

@Component({
    selector: 'app-other-bottle-size-wizard',
    templateUrl: './other-bottle-size-wizard.component.html',
    styleUrls: ['./other-bottle-size-wizard.component.scss'],
    standalone: false
})
export class OtherBottleSizeWizardComponent implements OnInit {

  alertWizardTitle:string;
  titelFontColor:string;
  bodyMessageColor:string;
  cancelButtonText:string;
  confirmButtonText:string;
  cancelButtonColor:string;
  confirmButtonColor:string;
  buttonglobalClass :string;
  isButtonOneDisabled :boolean;
  isButtonTwoDisabled :boolean;
  otherBottleSizes= new MatTableDataSource<EachOtherBottleSize>();
  displayedColumns = ["packCode", "bottleQty"]

  constructor(
    public dialogRef: MatDialogRef<OtherBottleSizeWizardComponent>,
    public dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data:any) {
      this.alertWizardTitle = data.title;
      this.cancelButtonText = data.cancelBtnText;
      this.confirmButtonText = data.confirmBtnText;
      this.otherBottleSizes.data = data.otherBottleSizes

      this.cancelButtonColor =
        data.cancelButtonColor == undefined
          ? "btn-light-blue"
          : data.cancelButtonColor;
      this.confirmButtonColor =
        data.confirmButtonColor == undefined
          ? "btn-light-red"
          : data.confirmButtonColor;
        this.buttonglobalClass  = data.buttonglobalClass == undefined?"end end":data.buttonglobalClass;
        this.isButtonOneDisabled = data.isButtonOneDisabled == undefined?false:data.isButtonOneDisabled;
        this.isButtonTwoDisabled = data.isButtonTwoDisabled == undefined?false:data.isButtonTwoDisabled;
    }

  ngOnInit(): void {
  }
closeDialog(response:boolean, buttonClick:number){
  this.dialogRef.close({event:'close', data:response, buttonClick:buttonClick })
}
}
